import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdControlsSuspense } from "api/generated/users/users";

export function usePartialControlsForUserFromGroupsQuery(userId: number) {
    return useGetUsersUserIdControlsSuspense(
        userId,
        { linked_from_groups: true },
        {
            query: {
                select: (response) => response.data,
                refetchOnMount: true,
                refetchOnWindowFocus: true,
                staleTime: STALE_TIME_RESOURCES,
            },
        }
    );
}
